import * as React from 'react';
import * as styles from './styles.css';

import { ArticleHeading4, ArticleParagraph1 } from '@cian/ui-kit';

import { IconFunctionalInformation16 } from '@cian/ui-kit-design-tokens/icons';

interface IEstimationDealTypeBannerProps {
  dealTypeText: string;
}

export const EstimationDealTypeBanner: React.FC<IEstimationDealTypeBannerProps> = ({ dealTypeText }) => {
  return (
    <div data-testid="EstimationDealTypeBanner" className={styles['container']}>
      <div className={styles['faq']}>
        <IconFunctionalInformation16 color="control-main-primary-pressed" />
      </div>
      <div className={styles['content']}>
        <div className={styles['title']}>
          <ArticleHeading4 color="text-primary-default">У нас пока нет оценки {dealTypeText}</ArticleHeading4>
        </div>
        <ArticleParagraph1 color="text-primary-default">
          Мы постоянно улучшаем сервис и увеличиваем покрытие данных. Совсем скоро у нас будет оценка
        </ArticleParagraph1>
      </div>
    </div>
  );
};

EstimationDealTypeBanner.displayName = 'EstimationDealTypeBanner';
